import { render, staticRenderFns } from "./RelacaoPatio.vue?vue&type=template&id=6fe58d17&"
import script from "./RelacaoPatio.vue?vue&type=script&lang=js&"
export * from "./RelacaoPatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports